export const themes = {
  default: ({ diamond = {}, hasSlideshow, isDesktop }) => {
    const thTopStyles = isDesktop ? { marginBottom: '3.4375rem' } : { marginBottom: '2.1875rem' };

    return {
      thRoot: 'bg-white',
      thTop: 'relative',
      thTopStyles: diamond ? thTopStyles : {},
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroStyles: hasSlideshow
        ? {
            minHeight: '102%',
            filter: 'blur(10px)',
            opacity: '0.25',
          }
        : {},
      thSlideshow: 'my-0 mx-auto w-full',
      thSlideshowStyles: { maxWidth: '45rem' },
      thDiamond: 'absolute bottom-0 left-1/2 -translate-x-50 translate-y-50 -mb-2px',
      thDiamondClassName: 'font-bold uppercase text-xs sm:text-sm',
      thDiamondSize: isDesktop ? 75 : 60,
      thBody: 'px-5 py-5 lg:py-4',
      thContent: 'max-w-site mx-auto w-full',
      thFooter: 'bg-gray-lighter overflow-hidden px-5',
    };
  },
};
